import chevronIcon from '../assets/icons/chevron-up.png';
import chevronIconDark from '../assets/icons/chevron-up-dark.svg';
import jobsIcon from '../assets/icons/jobs.png';
import jobGroupsIcon from '../assets/icons/job-groups.png';
import skillsIcon from '../assets/icons/skills.png';
import traitsIcon from '../assets/icons/traits.png';
import regionsIcon from '../assets/icons/regions.png';
import timeChangesIcon from '../assets/icons/time-changes.png';
import companiesIcon from "../assets/icons/company.png";
import companiesIconDark from "../assets/icons/company-dark.png";
import {useState} from "react";

const icons: any = {
    jobs: jobsIcon,
    jobGroups: jobGroupsIcon,
    skills: skillsIcon,
    traits: traitsIcon,
    regions: regionsIcon,
    timeChanges: timeChangesIcon,
    companies: companiesIcon,
    companiesDark: companiesIconDark,
};

function Accordion({children, icon, title, description, isLight = false}: any) {
    const [isOpened, setIsOpened] = useState(true);

    const iconName = isLight ? icon + 'Dark' : icon;
    const iconSrc = icons[iconName] ?? icons[icon];

    function toggleAccordion() {
        setIsOpened((prev) => !prev);
    }

    return (
        <div className={`w-full py-8 border-b xl:py-16 ${isLight ? 'bg-grey-200 border-grey-300' : 'bg-grey-900 border-grey-700'}`}>
            <div className={`container max-w-3xl ${isLight ? 'text-grey-900' : 'text-grey-100'}`}>
                <div className="flex items-center gap-4">
                    <img src={iconSrc} width="30" height="30" alt={title}/>
                    <h2 className="font-sweing text-3xl xl:text-4xl font-medium">{title}</h2>
                    <button onClick={toggleAccordion} className="ms-auto md:hidden">
                        <img src={isLight ? chevronIconDark : chevronIcon} width="15" alt={isOpened ? 'Close' : 'Open'}
                             className={`${isOpened ? 'rotate-180' : 'rotate-0'}`}/>
                    </button>
                </div>

                <div className={`pt-4 ${isOpened ? 'block' : 'hidden'}`}>
                    <p className="font-body text-sm" dangerouslySetInnerHTML={{__html: description}} />
                    <div className="pt-4">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Accordion;